import { SuccessRO } from '@routellers/types/dist/shared/success.ro';

import { ApiMethodDeclaration } from '..';

type ParamsData = number;

type ResponseData = SuccessRO;

export const regenerateNamespace: ApiMethodDeclaration<ParamsData, ResponseData> = (id) => ({
    url: `/namespace/regenerate/${id}`,
    method: 'PATCH',
});
